module.exports = __webpack_public_path__ + "static/media/Spanish_US_Christina BG-46.e12ec50c.png";